import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

/**
 * Thin wrapper over OktaAuth's token manager. Tokens are owned and kept fresh by the Okta SDK
 * (auto-renewed before expiry) — this service no longer reads/writes localStorage directly.
 */
@Injectable({
    providedIn: 'root'
})
export class TokenService {

    constructor(@Inject(OKTA_AUTH) private oktaAuth: OktaAuth) { }

    getAccessToken(): string | undefined {
        return this.oktaAuth.getAccessToken();
    }

    getIdToken(): string | undefined {
        return this.oktaAuth.getIdToken();
    }

    hasAccessToken(): boolean {
        // getAccessToken() only returns a token while one is present and unexpired in the token
        // manager, so presence here implies validity — unlike the old localStorage check.
        return !!this.getAccessToken();
    }
}
